/** @file Component for confirming the termination of an active isolated exam session. */
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import * as form from '@/components/Form';
const TERMINATE_VALUE = 'terminate';
const Checkboxes = form.createTypedCheckboxes();
/** Checkbox UI asking the user to confirm they want to end their active isolated session. */
export const ConfirmEndingPreviousSession = tsx
    .componentFactoryOf()
    .create({
    name: 'confirm-ending-previous-session',
    props: {
        /** Whether the user has confirmed they want to terminate the isolated session. */
        value: p(Boolean).required,
    },
    /** @returns The rendered confirmation checkbox JSX. */
    render() {
        return (<Checkboxes class="text-inherit" legend="You have an active isolated exam session. Logging in here will terminate it. Do you want to continue?" legendClasses="text-inherit" options={[
                {
                    tag: 'option',
                    value: TERMINATE_VALUE,
                    label: 'I want to continue to login and terminate my previously existing sessions.',
                },
            ]} value={new Set(this.value ? [TERMINATE_VALUE] : undefined)} onInput={value => {
                this.$emit('input', value.size > 0);
            }}/>);
    },
});
